import { Check, ClipboardList, Target, Handshake, Network, LineChart } from "lucide-react";
import { useSite, tx } from "@/lib/lang";
import { ui } from "@/lib/uiStrings";
import { Reveal, SectionLabel } from "./Reveal";
import SectionTabs from "./SectionTabs";

const STEP_ICONS = {
  1: ClipboardList,
  2: Target,
  3: Handshake,
  4: Network,
  5: LineChart,
};

export default function Metodo() {
  const { content, lang } = useSite();
  const steps = content.metodo || [];

  const stepContent = (s) => {
    const pts = s.points?.[lang] || s.points?.it || [];
    return (
      <>
        <h3 className="font-display text-xl sm:text-2xl font-bold text-ice">{tx(s.title, lang)}</h3>
        {tx(s.lead, lang) && <p className="mt-3 font-serif italic text-lg text-azure leading-snug">{tx(s.lead, lang)}</p>}
        <p className="mt-4 text-base text-muted-foreground leading-relaxed">{tx(s.desc, lang)}</p>
        <ul className="mt-6 space-y-3">
          {pts.map((p, i) => (
            <li key={i} className="flex items-start gap-3 text-sm text-ice/85">
              <Check size={16} className="mt-0.5 text-azure shrink-0" />
              {p}
            </li>
          ))}
        </ul>
      </>
    );
  };

  const items = steps.map((s) => {
    const StepIcon = STEP_ICONS[s.num] || ClipboardList;
    return {
      id: s.num,
      badge: <StepIcon size={18} />,
      title: tx(s.tab, lang) || tx(s.title, lang),
      render: () => stepContent(s),
    };
  });

  return (
    <section id="metodo" data-testid="metodo-section" className="py-16 lg:py-24 bg-surface/30 border-y border-ice/5">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal className="max-w-2xl">
          <SectionLabel>{ui[lang].labels.metodo}</SectionLabel>
          <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug text-ice">
            {tx(content.sezioni?.metodo?.heading, lang) || ui[lang].metodo.heading}
          </h2>
          <p className="mt-4 font-serif italic text-lg text-azure" data-testid="metodo-claim">
            {tx(content.sezioni?.metodo?.claim, lang) || ui[lang].metodo.claim}
          </p>
          <p className="mt-3 text-base text-muted-foreground">{tx(content.sezioni?.metodo?.sub, lang) || ui[lang].metodo.sub}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-14">
            <SectionTabs items={items} ariaLabel={ui[lang].metodo.heading} testIdPrefix="metodo-step" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
